import React, { useState, useCallback } from "react";
import { connect } from "react-redux";
import { LoadPanel } from "devextreme-react/load-panel";
import TextBox from "devextreme-react/text-box";
import Button from "devextreme-react/button";
import axios from "axios";
import { alert, confirm } from 'devextreme/ui/dialog';
function AutoGenerateCrate(props) {
    const [loadPanelVisible, setLoadPanelVisible] = useState(false);
    const [recordCount, setRecordCount] = useState(1); // For input
    const position = { of: "#accordion-containe2" };

    const handleGenerateClick = async () => {
        const count = parseInt(recordCount, 10);
        if (!count || count <= 0) {
            alert("Please enter a Quantity greater than 0.","Error");
            return;
        }
        try {
            setLoadPanelVisible(true);
            const formData = new FormData();
            formData.append("records", count);
            const response = await axios.post(
                `${window._env_.REACT_APP_APIS}/im/Crate/AddCrates`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${props.oidc.user.access_token}`,
                    },
                }
            );
            //alert("Crates generated successfully.");
            if (props.onClosePopup) {
                props.onClosePopup();
                props.RefereshGrid();
            }
        } catch (error) {
            console.error("Error:", error);
            // alert("An error occurred while generating crates.");
        } finally {

            setLoadPanelVisible(false);
        }
    };

    return (
        <div className="FormMt container-fluid" style={{ height: "96%", paddingTop: "20px" }}>
            <LoadPanel
                shadingColor="rgba(0,0,0,0.4)"
                position={position}
                onHiding={() => setLoadPanelVisible(false)}
                visible={loadPanelVisible}
                showIndicator={true}
                shading={true}
                showPane={true}
                hideOnOutsideClick={false}
            />
            {/* Row for TextBox */}
            <div className="row">
                <div className="col-md-12">
                    <TextBox
                        id="crateCount"
                        value={recordCount}
                        onValueChanged={(e) => setRecordCount(e.value)}
                        placeholder="Enter Quantity"
                        width="100%"
                        mode="number"
                        inputAttr={{ min: 1 }}
                        labelMode='static'
                        label='Quantity'
                        stylingMode='outlined'
                    />
                </div>
            </div>
            <div className="row accordianLastRow">
                <div className="col-md-12">
                    <Button
                        text="Ok"
                        type="default"
                        stylingMode="contained"
                        width={120}
                        onClick={handleGenerateClick}
                    />
                </div>
            </div>
        </div>
    );
}

function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}

export default connect(mapStateToProps)(AutoGenerateCrate);
